import NotFound from '../components/NotFound';
import DefaultLayout from '../layouts/DefaultLayout';
import ProductFinderLayout from '../components/ProductFinder/ProductFinderLayout';
import CHECKOUT_ROUTES from './checkout/routes';
import ProductFinder from '../components/ProductFinder';
import { productFinderRoutes } from '../../config/routes.config';
import { routes as SHOP_ROUTES } from '../shop';
import { FEATURE_MAGENTO2 } from '../../config/common.config';
import Pricing from '../shop/pages/Pricing/Pricing';
import PricingLayout from '../shop/pages/Pricing/PricingLayout';
import NotFoundLayout from '../components/NotFound/NotFoundLayout';

export const PRODUCT_FINDER_SEGMENT = 'catalog';

const routes = [
  ...CHECKOUT_ROUTES,
  ...(FEATURE_MAGENTO2 ? SHOP_ROUTES : []),
  {
    ...productFinderRoutes.productFinder,
    component: ProductFinder,
    layout: ProductFinderLayout,
  },
  {
    path: `/:language/pricing/:url_key`,
    name: `pricing`,
    component: Pricing,
    layout: PricingLayout,
  },
  {
    path: '*',
    name: 'notfound',
    component: NotFound,
    layout: NotFoundLayout,
  },
].map((route) => ({
  ...route,
  layout: route.layout || DefaultLayout,
}));

export default routes;
